<div class="flex flex-col gap-4">
  <p-tree
    id="treeComponent"
    [value]="knownVars"
    class="w-full md:w-[30rem]"
    selectionMode="single"
    [(selection)]="selectedVar"
    (onNodeSelect)="nodeSelect($event)"
    [filter]="true"
    [virtualScroll]="true"
    [virtualScrollItemSize]="30"
    [scrollHeight]="treeHeight"
  ></p-tree>

  <div class="flex flex-col gap-1">
    <label for="explanation">{{ myTranslation("officeAddin.explanation") }}</label>
    <textarea
      rows="5"
      cols="30"
      id="explanation"
      pTextarea
      [(ngModel)]="explanation"
      class="w-full h-[5rem]"
      readonly="true"
    ></textarea>
  </div>

  <div class="flex flex-col gap-1">
    <label for="example">{{ myTranslation("officeAddin.example") }}</label>
    <input pInputText id="example" class="w-full h-[2rem]" [(ngModel)]="example" readonly="true" />
  </div>

  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-2">
      <label for="syntax">{{ myTranslation("officeAddin.syntax") }}</label>
      @if (isDesktop) {
        <i class="pi pi-copy cursor-pointer" (click)="copyToClipboard()"></i>
      } @else {
        <label [pTooltip]="myTranslation('officeAddin.clipBoardExplanation')" class="pi pi-info-circle"></label>
      }
    </div>
    <textarea
      rows="5"
      cols="30"
      id="syntax"
      pTextarea
      [(ngModel)]="syntax"
      class="w-full h-[9rem]"
      readonly="true"
    ></textarea>
  </div>
</div>
